export default __webpack_public_path__ + "static/media/loader.a3143f0b.gif";